<template>
  <v-app
    id="body"
    class="ma-0 pa-0"
  >

        <!--------------------------------->
        <!--      Main App Contents      -->
        <!--------------------------------->
    <v-content
      v-if="showLoadingBar"
    >
      <v-card
        v-resize="onResize"
        class="d-flex align-stretch"
        :height="windowHeight"
      >
        <v-row
          align="center"
          justify="center"
          no-gutters
        >
          <v-col
            class="text-center mb-12 mx-10"
            xs="12"
            sm="8"
            md="6"
            lg="4"
            xl="4"
          >
            Loading ...
            <br>
            <br>
            <v-progress-linear
              color="#74cf74"
              indeterminate
              rounded
              height="8"
            >
            </v-progress-linear>
          </v-col>
        </v-row>
      </v-card>
    </v-content>

    <v-content
      v-else
    >
      <Header
        v-if="showHeader"
        class="ma-0 pa-0"
      />
      <v-card
        class="my-0 py-0"
        v-resize="onResize"
        :height="windowHeight"
        style="overflow-y: auto; overflow-x: none"
      >
        <v-row
          justify="center"
          no-gutters
        >
          <router-view
            class="ma-0 pa-0"
            id="router-view"
          />
        </v-row>
      </v-card>
    </v-content>


        <!--------------------------------->
        <!--       Main App Footer       -->
        <!--------------------------------->    
    <!-- <v-footer
      app
      v-if="showFooter"
      color="grey lighten-4"
      height="50px"
    >

      <v-row
        justify="center"
      >
        <v-col
          class="ma-0 pa-0 text-center"
          cols="12"
          xs="12"
          sm="12"
          md="6"
          lg="6"
          xl="4"
        >
          <v-row
            justify="center"
            no-gutters
          >
            <v-col
              v-for="(page,p) in nav"
              class="ma-0 pa-0"
              :key="p"
            >
              <v-btn
                icon
                small
                :to="{name: page.href}"
                @click.prevent="jumpToToday"
              >
                <v-icon
                  medium
                  color="grey darken-3"
                >
                    {{page.icon}}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-footer> -->

  </v-app>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import Header from '@/components/Header.vue'

  export default {
    data: () => ({

    }),

    components: {
      Header
    },

    beforeCreate() {
      Auth.currentSession()
      .then(
        session => {
          if (session.idToken.payload['custom:status'] == 'verified'){
            this.$store.dispatch('data/updateStepper',6);
          }
          this.$store.dispatch('data/session',session);
          console.log('session:',session);
          this.$store.dispatch('login/signIn',session.idToken.payload.email);
        }
      )
      .catch(
        error => {
          console.log(error);
          // this.$store.dispatch('login/signOut');
        }
      );

    },

    watch: {
      // '$route.name': function () {
      //   this.checkURL();
      // }
    },

    methods: {
      jumpToToday() {
        this.$store.dispatch('menu/resetWeekOffset');
        // if (window.location.href.indexOf("calendar") >= 0) {
          //  this.$vuetify.goTo('#anchor');
        // }
      },

      onResize() {
        this.$store.dispatch('data/resizeWindow');
      },

      signOut() {
        this.$store.dispatch('login/signOut');
      },

      redirectToMenu() {
        this.$router.push('/menu');
      },


    },

    computed: {
      showHeader() {
        if (this.$route.name == 'signup') {
          return false;
        } else {
          return true;
        }
      },

      signedIn() {
        return this.$store.getters['login/signedIn'];
      },

      dataLoaded() {
        return this.$store.getters['data/dataLoaded'];
      },

      showLoadingBar() {
        if (this.signedIn && !this.dataLoaded){
          return true
        } else {
          return false
        }
      },

      windowHeight() {
        if (!this.showHeader || this.showLoadingBar) {
          return this.$store.getters['data/windowHeight'];
        } else {
          return (this.$store.getters['data/windowHeight'] - 64);
        }
      },

      windowWidth() {
        return this.$store.getters['data/windowWidth'];
      },
      
      accountInfo() {
        return this.$store.getters['data/account'];
      },


    }

  }
</script>


<style>
  .sign-out {
    width: 160px;
    margin: 0 auto;
  }

  a {
    text-decoration: none;
    color: #212121;
  }

  .body {
    background: white;
    font-family: 'Spartan', sans-serif;
  }

  .logo {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    font-size: 20px;
    color: #212121;
  }

  .mainContent {
    overflow-y: auto;
    padding: 0px;
  }

  .nav1 {
    font-size: 1.0em;
    font-weight: 400;
    color: #424242;
    letter-spacing: 1px;
    white-space: nowrap;
  }
</style>